import React from 'react';
import { connect } from "react-redux";
import './../main.scss'
import './../../main.css'
import Tabs from './tabs'

export class Main extends React.Component{
	constructor(props) {
		super(props);
	
		document.title= "Opći podaci"
		this.state={
			error: false,
			signin: true,
			userName: "",
			password: "",
		} 
	}
    componentDidMount = async () => {		

    }

    render(){  
      
        return(    
            <main style={{}}>
                <header>
                    <h1>
                        DASHBOARD
                    </h1>      
                </header>

               <Tabs />
            </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.user.userLoggedIn,
        asideToggled: state.client.asideToggled,
		adminProps: state.admin,
		client: state.client,
		role: state.user.role
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Main);
